/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import AlpsForm from './layout';
import { formValidation } from './validation';
import {
  getSelectedEntityId,
  userHasUpdatePermission,
  isCreating,
  isUpdating,
  isInherited
} from '../../../redux/modules/entities/selectors';
import {
  selectAlpsFormInitialValues,
  getCurrentParentFormValues,
  getSelectableVersionList,
  isCreatingEntity,
  handlePendingSubmit,
  changeVersion,
  selectTypesForDisplay,
  selectAlpsTypesForDisplay,
  formTypeHasSubtypes,
  setAlpsFomrValues
} from '../../../redux/modules/entities/alps/selectors';
import { entitiesMetaData } from '../../../redux/modules/entities/metaData';
import { formSubmission, createFormName } from '../../../redux/modules/form/selectors';
import store from '../../../redux/store';
import { setSelectedSubEntityId } from '../../../redux/modules/entities';


const CreateAlpsForm = compose(
  connect(createFormName),
  reduxForm({
    onSubmit: (values, dispatch, props) => {
    let boolIsCreatingEntity=isCreatingEntity(store.getState());
    if(boolIsCreatingEntity == true){ //create case
    handlePendingSubmit(values, dispatch, props, store.getState())
    return  dispatch(setSelectedSubEntityId('create'));  
    }else{ //change version case
      dispatch(changeVersion(values.get('version'),dispatch));
    }
    },
    validate: formValidation,
    destroyOnUnmount: true,
  })
)(AlpsForm);

export function mapStateToProps(state) {
  var div = document.getElementById('sdpanel-submit');
  if(div){
  div.innerHTML = div.innerHTML.replace('Submit','Next');
  }
  return {
    initialValues: selectAlpsFormInitialValues(state),
    userHasUpdatePermission: userHasUpdatePermission(state),
    isCreatingEntity: isCreatingEntity(state),
    isSaving: isUpdating(state) || isCreating(state),
    key: getSelectedEntityId(state),
    actionTypes: entitiesMetaData.alps.actionTypes,
   artifactTypes: isCreatingEntity(state) == true ? selectAlpsTypesForDisplay(state) : selectTypesForDisplay(state),
    artifactSubtypes: entitiesMetaData.alps.artifactSubtypes,
    currentFormValues: getCurrentParentFormValues(state),
    selectableVersions: getSelectableVersionList(state),
    typeHasSubtypes: formTypeHasSubtypes(state),
    inherited: isInherited(state),
  };
}

export default connect(mapStateToProps)(CreateAlpsForm);
